module.exports = __webpack_public_path__ + "media/LandingPageAssets/alcoholeTool-5d1fd205.png";